var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"branding","role":"banner"}},[_c('router-link',{attrs:{"to":"/home"}},[_c('img',{staticClass:"img-responsive",attrs:{"alt":"","role":"presentation","src":require("../assets/header-image.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }